export const UNREAD_COUNT_EVENT_TYPE = "unread_count";

/**
 * Validates a Firebase data-only `unread_count` event and returns the count to
 * apply to the badge, or `null` when the event must be ignored.
 *
 * FCM data payloads are always strings, so values are cast to Number. The count
 * is applied only when `company_site_id` matches the active tenant; events from
 * other tenants (the backend emits to every device of the user) are ignored.
 */
export function resolveRealtimeUnreadCount(
  data: Record<string, string | undefined>,
  activeCompanySiteId: number | null
): number | null {
  if (data.type !== UNREAD_COUNT_EVENT_TYPE) return null;

  const eventCompanySiteId = Number(data.company_site_id);
  if (
    activeCompanySiteId === null ||
    !Number.isFinite(eventCompanySiteId) ||
    eventCompanySiteId !== activeCompanySiteId
  ) {
    return null;
  }

  const unreadCount = Number(data.unread_count);
  if (!Number.isFinite(unreadCount) || unreadCount < 0) return null;

  return unreadCount;
}
